<template>
	<div class="events">
		<filters @changeFilters="filtersChanged" :calendarApi="calendarApi"></filters>
		<more :calendarApi="calendarApi"></more>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from "vuex"

	import Arrow from "./Arrow"
	import More from "./EventMore"
	import Filters from "./Filters"
	import VueDatepicker from "vuejs-datepicker"

	export default {
		props: {
			calendarApi: {
				type: Object,
				default: null,
			},
		},
		computed: {
			...mapGetters([
				"getExpandedDay",
				"getEvents",
				"getSelectedEvent",
				"getCurrentView",
				"getStoredEvents",
				"getStoredDates",
			]),
			day() {
				return this.getExpandedDay;
			},
			sortedEvents() {
				let arrayToSort = this.getStoredDates[this.day].events;

				return arrayToSort.sort(function (eventA, eventB) {
					if (moment(eventA.start).isAfter(eventB.start)) {
						return 1;
					} else if (moment(eventA.start).isBefore(eventB.start)) {
						return -1;
					} else {
						return 0;
					}
				});
			},
		},
		methods: {
			...mapActions(["updateSidebar"]),
			filtersChanged() {
				this.$emit('changeFilters');
			},
			setExpandedDay(date) {
				var newDate = this.formatDate(date);

				if (this.calendarApi) {
					this.calendarApi.gotoDate(newDate);
				}
				this.updateSidebar(newDate);

				let viewToURL = "";
				switch (this.getCurrentView) {
					case "agendaDay":
						viewToURL = "day";
						break;
					case "agendaWeek":
						viewToURL = "week";
						break;
					default:
						viewToURL = this.getCurrentView;
				}

				this.$router.push({
					name: "calendarExpanded",
					params: {
						currentView: viewToURL,
						expandedDay: newDate,
					},
				});
			},
		},
		components: {
			Arrow,
			More,
			VueDatepicker,
			Filters,
		},
	};
</script>

<style lang="scss">
	@import "../../assets/scss/_variables.scss";

	.events {
		width: 250px;
		border-left: 2px solid $light;
		position: relative;
		overflow: hidden;
		transition: all 200ms ease-in-out;

		&.showingMore {
			width: 320px;
		}

		.vdp-datepicker input {
			text-align: center;
			margin: 0;
			font-size: $font-size-largest;
			background: transparent;
			border: 0;
			padding: 0;
			width: 160px;
			color: $darkest;
			cursor: pointer;
		}

		.list {
			width: 100%;
			position: absolute;
			transition: transform 0.4s;
		}

		.day {
			padding: 1rem;
			border-bottom: 1px solid $light;
			color: $dark;

			> h3 {
				flex-grow: 1;
			}

			> .arrow {
				cursor: pointer;

				[class^="ico-"] {
					font-size: 0.5rem;
					margin-left: 0.75rem;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Events.vue?256af67f